import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { systemConfigGuard } from './guards/system-config.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    canActivate: [systemConfigGuard],
    title: 'Начало - Ресторант Дъгата'
  },
  {
    path: 'menu',
    loadComponent: () => import('./pages/menu/menu.component').then(m => m.MenuComponent),
    canActivate: [systemConfigGuard],
    title: 'Меню - Ресторант Дъгата'
  },
  {
    path: 'delivery-info',
    loadComponent: () => import('./pages/delivery-info/delivery-info.component').then(m => m.DeliveryInfoComponent),
    canActivate: [systemConfigGuard],
    title: 'Условия за Доставка - Ресторант Дъгата'
  },
  {
    path: 'auth',
    loadComponent: () => import('./pages/auth/auth.component').then(m => m.AuthComponent),
    canActivate: [systemConfigGuard],
    title: 'Вход / Регистрация - Ресторант Дъгата'
  },
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
    canActivate: [systemConfigGuard, authGuard],
    title: 'Моят Профил - Ресторант Дъгата'
  },
  {
    path: 'checkout',
    loadComponent: () => import('./pages/checkout/checkout.component').then(m => m.CheckoutComponent),
    canActivate: [systemConfigGuard, authGuard],
    title: 'Завършване на Поръчката - Ресторант Дъгата'
  },
  {
    path: 'admin',
    loadComponent: () => import('./pages/admin/admin.component').then(m => m.AdminComponent),
    canActivate: [systemConfigGuard, adminGuard],
    title: 'Администрация - Ресторант Дъгата'
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms/terms.component').then(m => m.TermsComponent),
    canActivate: [systemConfigGuard],
    title: 'Общи Условия - Ресторант Дъгата'
  },
  {
    path: 'privacy',
    loadComponent: () => import('./pages/privacy/privacy.component').then(m => m.PrivacyComponent),
    canActivate: [systemConfigGuard],
    title: 'Политика за Поверителност - Ресторант Дъгата'
  },
  {
    path: 'system-error',
    loadComponent: () => import('./pages/system-error/system-error.component').then(m => m.SystemErrorComponent),
    title: 'Временен Проблем - Ресторант Дъгата'
  },
  {
    path: '**',
    redirectTo: ''
  }
];
